'use es6';

import ScriptloaderInstallModalPanel from 'ui-addon-scriptloader/components/ScriptloaderInstallModalPanel';
export default ScriptloaderInstallModalPanel;